module.exports = __webpack_public_path__ + "img/xmxxPad.f243ad67.png";